export default __webpack_public_path__ + "static/media/box-logo.ad784b55.png";